// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 737 ? "fb7d5399" : chunkId) + "." + {"640":"ead2d3395602eac6","737":"7d5edc9d682b25cd"}[chunkId] + ".js";
};